<div class="modal1Main" *ngIf="infoData">
  <div class="modalHeader">
    <span class="title">
      League Preview
    </span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div>
  <div class="fantasyGameHead" [ngStyle]="{'padding-bottom':(infoData.join_btn==false &&infoData.unregister_enable == false)?'10px':''}">
    <div class="row"  style="display: flex;align-items: center;">
      <div class="col s8 m8 l8 x8"> 
        <h3 [ngStyle]="{'font-size':infoData.name.length>50?'14px':''}"><img src="{{assetURL}}/assets/default/images/{{infoData?.league_type}}{{darkMode_ext}}.svg?v=2.7.5" alt=""> {{infoData.name}} </h3>
      </div>
      <div class="col s4 m4 l4 x4">
        <button *ngIf="infoData.join_btn == true;else unregister" mat-raised-button color="primary" class="joinDraftBtn" (click)="joinLeaguePopup(infoData.league_code)">Join</button> 
        <ng-template #unregister>
          <button *ngIf="infoData.unregister_enable == true" mat-raised-button color="danger" class="joinDraftBtn unregister" (click)="confirmDialog(infoData.league_code)">Unregister</button>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="invite_PanelTab" style="min-height: 265px;">
    <mat-tab-group class="dtable panelContainer" (selectedTabChange)="leagueTabChanged($event)">
      <mat-tab>
        <ng-template mat-tab-label class="tabLabel">
          <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
          Info
        </ng-template>
        <div>
          <div class="row">
            <div class="parent-info">
              <div class="col s12 m6 l6 xl6 lobbyInfoLeft lobbyInfo">
                <h2>Contest Info</h2>
                <ul style="padding-bottom: 5px;">
                  <li *ngFor="let record of infoData.info">
                    <span class="left">{{record.label}}: </span>
                    <span class="right bbb" *ngIf="record.label == 'Buy-In';else otherInfo">${{ record.value.replace("$","") | number:'1.2-2' | Price }}</span>
                    <ng-template #otherInfo>
                      <span class="right">{{record.value}}</span> 
                    </ng-template>
                  </li>  
                </ul>
              </div>
              <div class="col s12 m6 l6 xl6 lobbyInfoLeft lobbyInfo">
                <h2>Prizes</h2>
                <ul>
                  <li *ngFor="let prize of infoData.prize">
                    <span class="left">{{prize.rank}}: </span>
                    <span class=""><span class="pricespan">${{ prize.amount | number:'1.2-2' | Price }}</span></span>
                  </li> 
                </ul>
              </div>
            </div>
            <div class="col s12 m12 l12 xl12">
              <div class=" lobbyInfo">
                <h2 class="entranceTitle"> Entrants <span> ({{infoData.joined_entrants}} of {{infoData.entrants}})</span> </h2>
                <div class="entrantsList">
                  <ul *ngIf="entrantsData" #entrantsSlide>
                    <span *ngIf="entrantsData.length>6 && showprev" (click)="scrollToEnd('Prev')" class="prev arrows"></span>
                    <li *ngFor="let entrant of entrantsData">
                      <div [ngStyle]="{'background-image': 'url('+ assetURL+'/'+ entrant.picture + ')','background-size': 'cover'}"  class="profile-post">
                        <span class="startIcon_join" *ngIf="entrant.premium_star">
                          <i class="starhover zmdi zmdi-star" tooltip="{{entrant.premium_star_msg}}" [options]="tooltipPly"></i>
                        </span>
                      </div>
                      <span>{{entrant.drafters_id}}</span>
                    </li>
                    <span *ngIf="entrantsData.length>6 && shownext" (click)="scrollToEnd('Next')" class="next arrows"></span>
                  </ul>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label class="tabLabel dtableCell" >
          <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
          Roster & Scoring
        </ng-template>
        <div *ngIf="!scoringData"> 
          <h4 class="text-center">Loading...</h4> 
        </div>
        <div class="infoMain" *ngIf="scoringData">
          <div class="row">
            <div class="parent-info">
              <div class="col s12 m6 l6 xl6 infoIndiv">
                <h2>Roster Positions</h2>
                <perfect-scrollbar [config]="config" style="max-width: 100%; max-height: 265px;">
                  <ul>
                    <li *ngFor="let position of scoringData.roster_positions">{{position.display_name}} <span class="float-right">{{position.value}}</span></li> 
                  </ul>
                </perfect-scrollbar>
              </div>
              <div class="col s12 m6 l6 xl6 infoIndiv"> 
                <h2>Scoring</h2>
                <perfect-scrollbar [config]="config" style="max-width: 100%; max-height: 265px;"> 
                  <div *ngFor="let score of scoringData.scoring">
                    <h3 _ngcontent-c19="" *ngIf="score.label">{{score.label}}</h3>
                    <ul>
                      <li *ngFor="let rec of score.value">{{rec.display_name}} <span class="float-right">{{rec.value}}</span></li> 
                    </ul>
                  </div> 
                </perfect-scrollbar> 
              </div>
            </div>
          </div> 
        </div>
      </mat-tab>

      <mat-tab *ngIf="infoData.duration_id != 8">
        <ng-template mat-tab-label class="tabLabel dtableCell">
          <!-- <mat-icon class="example-tab-icon">thumb_up</mat-icon> -->
          Schedule
        </ng-template>
        <div *ngIf="!schedulesData"> 
          <h4 class="text-center">Loading...</h4> 
        </div>
        <div class="entrantsList2" *ngIf="schedulesData">
          <perfect-scrollbar class=" maxHei400" [config]="config" style="max-width: 100%;">
            <div *ngFor="let schedule of schedulesData.eventData">
              <div class="entrantsDate">{{schedule.start_time}}</div>
              <div class="entrantsBox1" *ngFor="let event of schedule.events">
                <ul>
                  <li class="categoryName">
                    <img src="{{event.image_first}}" alt="">
                      {{event.loc_first}}
                  </li>
    
                  <li class="categoryA">@</li>
                  <li class="categoryName">
                    <img src="{{event.image_second}}" alt="">
                    {{event.loc_second}}
                  </li>
                  <li class="eventTime">
                    {{event.time_format}}
                    <span>{{event.prefix}}, {{event.time_zone}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </perfect-scrollbar>
        </div> 
      </mat-tab>
    </mat-tab-group>

  </div>
</div>
<div class="modalFooter row" style="padding: 0px 1rem 1rem 1rem;">
  <div class="col s6 m6 l6 xl6">
    <a href="{{siteUrl+'/'+'rules'}}" class="popuplink1">
      Site Rules & Scoring
    </a>
  </div>
  <div class="col s6 m6 l6 xl6">
    <a href="{{siteUrl+'/league/profile/'+infoData.league_type+'/'+infoData.league_code}}" class="popuplink1 float-right">
      Go to League Home
    </a>
  </div>
</div>
</div>

